export enum ScholarshipItemStatus {
	COMPLETED = 'Completed',
	NOT_AVAILABLE = 'NotAvailable',
	PENDING = 'Pending',
	LAST_STEP = 'LastStep',
	PARTIAL_CONFIRMATION = 'PartialConfirmation',
}
